import "rxjs/add/operator/mergeMap";
import { Types, Creators } from "../reducer";

import * as firebase from "firebase";

export default action$ =>
  action$.ofType(Types.DELETE_ISSUE).mergeMap(action => {
    return firebase
      .database()
      .ref(`issues/${action.customerKey}/${action.issueKey}`)
      .remove()
      .then(() => Creators.actionSucceeded())
      .catch(() => Creators.showMessage("Delete Issue Failed"));
  });



// WEBPACK FOOTER //
// ./src/customer/epics/deleteIssue.js